import React from "react";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnalysisTeam } from "types";
import { Table } from "@avlino-inc/alenza-react";
import styles from "components/dashboard/Dashboard.module.scss";

const AnalysesTeamsTable = ({
  analysisTeams,
  rowEvents,
  trashCellCallback,
  showAccount,
  cardTable
}: {
  analysisTeams: AnalysisTeam[];
  rowEvents: any;
  trashCellCallback: Function;
  showAccount?: boolean;
  cardTable?: boolean;
}) => {
  const trashIconFormatter = (cell: any, row: any) => {
    return (
      <FontAwesomeIcon
        key={row.id}
        icon={["fal", "trash-alt"]}
        style={{ color: "red" }}
      />
    );
  };
  const { SearchBar } = Search;
  const columns: Array<Object> = [
    {
      dataField: "team_name",
      text: "Team",
      sort: true,
      headerAlign: "left",
      align: "left"
    },
    {
      dataField: "actions",
      text: "Action",
      headerAlign: "left",
      align: "left",
      isDummyField: true,
      formatter: trashIconFormatter,
      events: {
        onClick: (
          e: any,
          column: any,
          columnIndex: number,
          row: AnalysisTeam,
          rowIndex: number
        ) => {
          trashCellCallback(row.id);
        }
      }
    }
  ];
  if (showAccount) {
    columns.push({
      dataField: "account_name",
      text: "Account",
      headerAlign: "left",
      align: "left"
    });
  }
  let dataSorted =
    analysisTeams &&
    analysisTeams.sort((a: AnalysisTeam, b: AnalysisTeam) =>
      a.team_name.localeCompare(b.team_name)
    );
  return (
    <div>
      {analysisTeams ? (
        <ToolkitProvider
          keyField="id"
          data={dataSorted}
          columns={columns}
          search
        >
          {(props: any) => (
            <>
              <div className={styles["table__search-container"]}>
                <SearchBar
                  className={styles["table__search-container__search-bar"]}
                  {...props.searchProps}
                />
              </div>
              <div className={Table.classNames.table}>
                {cardTable ? (
                  <BootstrapTable
                    {...props.baseProps}
                    classes="card-table text-center"
                    bordered={false}
                    bootstrap4
                    rowEvents={rowEvents}
                  />
                ) : (
                  <BootstrapTable
                    {...props.baseProps}
                    bordered={false}
                    bootstrap4
                    hover
                    condensed
                    rowEvents={rowEvents}
                  />
                )}
              </div>
            </>
          )}
        </ToolkitProvider>
      ) : (
        <p>No Teams have been granted permission to this Analysis</p>
      )}
    </div>
  );
};

export default AnalysesTeamsTable;
